// BASE SETTING to VUE
import bus from './bus';
// Imports
import Vue from 'vue';
import api from './api';
import moment from 'moment';
import UTIL from '@/utils/index';
import iView from 'view-design';
import lazyload from '../directives/lazyload';
import Draggable from '../directives/draggable';
import Droppable from '../directives/droppable';
Vue.use(iView);
import Contextmenu from 'vue-contextmenujs';
Vue.use(Contextmenu);

Vue.directive('lazy-load', lazyload);
Vue.directive('draggable', Draggable);
Vue.directive('droppable', Droppable);
Vue.prototype.$register = (name, instance) => {
  Vue.prototype[name] = instance;
};
// markdown
import VueMarkdownEditor from '@kangc/v-md-editor';
import githubTheme from '@kangc/v-md-editor/lib/theme/github';
import createLineNumbertPlugin from '@kangc/v-md-editor/lib/plugins/line-number/index';
import createHighlightLinesPlugin from '@kangc/v-md-editor/lib/plugins/highlight-lines/index';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import '@kangc/v-md-editor/lib/plugins/highlight-lines/highlight-lines.css';
VueMarkdownEditor.use(createHighlightLinesPlugin());
// highlightjs 核心代码
import hljs from 'highlight.js/lib/core';
// 按需引入语言包
import json from 'highlight.js/lib/languages/json';
import javascript from 'highlight.js/lib/languages/javascript.js';
import py from 'highlight.js/lib/languages/python';
hljs.registerLanguage('json', json);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('python', py);


import pick from 'lodash/pick';
import omit from 'lodash/omit';

/** 与 store/session 中 push_* 一致的线程预设；$open({ type, params }) 时据此生成 path / base_url / icon 等 */
const THREAD_OPEN_DEFAULTS = {
  icon: 'md-link',
  size: 24,
};

const THREAD_OPEN_PRESETS = {
  'project-create': (p) => {
    if (p.id == null) {
      throw new Error('type project-create requires params.id');
    }
    return {
      icon: 'Building-',
      type: 'project',
      size: 24,
      path: `/core/projects/${p.id}/create`,
      base_url: `/core/projects/${p.id}`,
      name: p.name,
    };
  },
  'flow-instance': (p) => {
    if (p.id == null) {
      throw new Error('type flow-instance requires params.id');
    }
    return {
      icon: 'lianjieliu',
      type: 'flow_instance',
      size: 24,
      path: `/core/flows/${p.id}/instance`,
      base_url: `/core/flows/${p.id}/instance`,
      name: p.name,
    };
  },
  'flow-create': (p) => {
    if (p.flow_id == null) {
      throw new Error('type flow-create requires params.flow_id');
    }
    let path = `/core/flows/${p.flow_id}/create`
    if (p.id != null) {
      path = path + `?model=${p.model}&id=${p.id}`
    }
    
    return {
      icon: 'fenzuguanli',
      type: 'flow',
      size: 24,
      path,
      base_url: path,
      name: p.name,
    };
  },
  /** 流程定义详情，对应 session/push_flow；path 使用 params.flow 或 params.id */
  flow: (p) => {
    const flow = p.flow != null ? p.flow : p.id;
    if (flow == null) {
      throw new Error('type flow requires params.flow or params.id');
    }
    return {
      icon: 'fenzuguanli',
      type: 'flow',
      size: 24,
      path: `/core/flows/${flow}/info`,
      base_url: `/core/flows/${flow}`,
      name: p.name,
    };
  },
  task: (p) => {
    if (p.id == null) {
      throw new Error('type task requires params.id');
    }
    return {
      icon: 'fenzuguanli',
      type: 'project',
      size: 24,
      path: `/core/itasks/${p.id}/dashboard`,
      base_url: `/core/itasks/${p.id}`,
      name: p.name,
    };
  },
  'edit-task': (p) => {
    if (p.id == null) {
      throw new Error('type edit-task requires params.id');
    }
    return {
      icon: 'fenzuguanli',
      type: 'project',
      size: 24,
      path: `/core/itasks/${p.id}/editor`,
      base_url: `/core/itasks/${p.id}`,
      name: p.name,
    };
  },
  /** 新建任务页，对应 tasks 中 itasks/create */
  'create-task': () => ({
    icon: 'fenzuguanli',
    type: 'project',
    size: 24,
    path: '/core/itasks/create/editor',
    base_url: '/core/itasks/create',
    name: undefined,
  }),
  contract: (p) => {
    if (p.id == null) {
      throw new Error('type contract requires params.id');
    }
    return {
      icon: 'contract',
      type: 'contract',
      size: 24,
      path: `/core/contracts/${p.id}/dashboard`,
      base_url: `/core/contracts/${p.id}`,
      name: p.name,
    };
  },
  'project-cm': (p) => {
    if (p.id == null) {
      throw new Error('type project-cm requires params.id');
    }
    return {
      icon: 'Building-',
      type: 'project',
      size: 24,
      path: `/core/projects/${p.id}/cm`,
      base_url: `/core/projects/${p.id}`,
      name: p.name,
    };
  },
  group: (p) => {
    if (p.id == null) {
      throw new Error('type group requires params.id');
    }
    return {
      icon: 'organization',
      type: 'dep',
      size: 24,
      path: `/core/groups/${p.id}/dashboard`,
      base_url: `/core/groups/${p.id}`,
      name: p.name,
    };
  },
};

function mergeOpenPreset(threadData) {
  const {type, params} = threadData;
  const builder = THREAD_OPEN_PRESETS[type];
  if (!builder) {
    return null;
  }
  const mergedParams = {
    ...(params || {}),
    ...pick(threadData, ['id', 'name', 'flow']),
  };
  const preset = builder(mergedParams);
  const userOverride = pick(threadData, ['icon', 'name', 'size', 'path', 'url', 'base_url']);
  const rest = omit(threadData, ['type', 'params', 'id', 'name', 'flow', 'icon', 'size', 'path', 'url', 'base_url']);
  let thread = {
    ...THREAD_OPEN_DEFAULTS,
    ...preset,
    ...rest,
  };
  Object.keys(userOverride).forEach((k) => {
    if (userOverride[k] !== undefined) {
      thread[k] = userOverride[k];
    }
  });
  return thread;
}

VueMarkdownEditor.use(githubTheme, {
  Hljs: hljs,
});
VueMarkdownEditor.use(createLineNumbertPlugin());
Vue.use(VueMarkdownEditor);

// Setup PuzzleVerification plugins
Vue.prototype.moment = moment;
Vue.prototype.Download = function(url) {
  const a = document.createElement('a');
  a.href = url;
  a.download = 'download';
  a.target = 'blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

Vue.prototype.$close = function() {
  const path = this.$route.path;
  const threads = this.$store.getters['session/threads'];
  const index = threads.findIndex((v)=>path && path.includes(v.base_url));
  let prev = '/dashboard';
  console.log(index, threads);
  if (index == -1) {
    if (threads.length != 0) {
      prev = threads[threads.length - 1].path || threads[threads.length - 1].url;
    }
  } else if (index > 0) {
    prev = threads[index-1].url || threads[index-1].path;
    this.$store.commit('session/remove', index);
  }
  console.log(prev);
  this.RouteTo(prev);
};


Vue.prototype.$util = UTIL;


// thread：支持完整 thread 对象，或 { type, params, icon?, name?, size? } 由预设生成（见 THREAD_OPEN_PRESETS）
Vue.prototype.$open = function(threadData) {
  if (typeof threadData !== 'object' || threadData === null) {
    throw new Error('threadData must be an object');
  }
  let thread;
  if (threadData.type && THREAD_OPEN_PRESETS[threadData.type]) {
    thread = mergeOpenPreset(threadData);
  } else {
    thread = {...threadData};
  }

  thread.icon = thread.icon != null ? thread.icon : THREAD_OPEN_DEFAULTS.icon;
  thread.name = thread.name != null ? thread.name : thread.path;
  thread.base_url = thread.base_url != null ? thread.base_url : thread.url;
  thread.size = thread.size != null ? thread.size : THREAD_OPEN_DEFAULTS.size;

  if (!thread.path && !thread.url) {
    throw new Error('$open: missing path/url; provide type+params or path/url');
  }

  this.$store.commit('session/push', thread);
  this.RouteTo(thread.url || thread.path);
};

Vue.prototype.$Notice.config({
  top: 50,
  duration: 3,
});

Vue.prototype.$bus = bus;
Vue.use(api);

const debouncePool = {};
Vue.prototype.debounce = (func, delayTime=500, options)=>{
  if (!func) {
    return;
  }
  let {timeStamp, timer} = debouncePool[func] || {};
  if (timeStamp && moment(timeStamp).isAfter(moment().subtract(300, 'seconds'))) {
    return;
  } else {
    clearTimeout(timer);
    delete debouncePool[func];
  }
  timer = setTimeout(() => {
    func(options);
    delete debouncePool[timer];
  }, delayTime);
  debouncePool[func] = {
    timer,
    timeStamp: moment().format(),
  };
};


// Predefined Some Easy Prompt Methods based on iview
Vue.prototype.Confirm = function(content, cb, cb2, option = {}) {
  this.$Modal.confirm({
    title: '操作确认',
    content,
    onOk: cb,
    onCancel: cb2 || (()=>{}),
    ...option,
  });
};

Vue.prototype.Error = function(obj) {
  this.$Modal.error({
    title: '错误',
    content: typeof obj == 'object'?obj.message:obj,
  });
};

Vue.prototype.$dev = (process.env.NODE_ENV !== 'production');

Vue.prototype.Success = function(param) {
  if (typeof param == 'object') {
    const {title, desc, content} = param;

    this.$Notice.success({title, desc: content || desc});
  } else {
    this.$Notice.success({title: '操作完成', desc: param});
  }
};

Vue.prototype.RouteBack = function() {
  window.history.go(-1);
};

Vue.prototype.RouteTo = function(path, newtab = false) {
  let query = null
  if(typeof path == 'object'){
    path = path.path;
    query = path.query;
  }
  if (window && window.event && window.event.ctrlKey) {
    newtab = true;
  }
  if (!path) {
    return;
  }

  // route to given url
  if (newtab) {
    if (!path.includes('http')) {
      const routerUrl = this.$router.resolve({
        path,
        query,
      });
      window.open(routerUrl.href, '_blank');
    } else {
      window.open(path, '_blank');
    }
  } else {
    if (!path.includes('http')) {
      if (this.$route.path != path) {
        this.$router.push(path);
      }
    } else {
      window.location.href = path;
    }
  }
};


import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
// Automatically loads and bootstraps files
// in the "./src/components/base" folder.
const requireComponent = require.context('@/components/base', true, /\.vue$/);

for (const file of requireComponent.keys()) {
  const componentConfig = requireComponent(file);
  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));
  Vue.component(`Base${componentName}`, componentConfig.default || componentConfig);
}

const requireComponentPanel = require.context('@/components/panel', true, /\.vue$/);

for (const file of requireComponentPanel.keys()) {
  const componentConfig = requireComponentPanel(file);

  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));
  Vue.component(`Panel${componentName}`, componentConfig.default || componentConfig);
}

const requireComponentFormControls = require.context('@/components/form/controls', true, /\.vue$/);
for (const file of requireComponentFormControls.keys()) {
  const componentConfig = requireComponentFormControls(file);
  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));

  Vue.component(`Ugo${componentName}`, componentConfig.default || componentConfig);
}

const requireComponentZZLFormControls = require.context('@/components/form/zzl/controls', true, /\.vue$/);
for (const file of requireComponentZZLFormControls.keys()) {
  const componentConfig = requireComponentZZLFormControls(file);
  const name = file
      .replace(/index.js/, '')
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '');
  const componentName = upperFirst(camelCase(name));

  Vue.component(`Zzl${componentName}`, componentConfig.default || componentConfig);
}


function getBlob(url, cb) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  xhr.send();
}

/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
function saveAs(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
function download(url, filename) {
  getBlob(url, function(blob) {
    saveAs(blob, filename);
  });
}

Vue.prototype.SaveAs = saveAs;
Vue.prototype.DownloadWithName = download;

Vue.directive('transfer', {
  inserted: (el) => {
    el.parentElement.removeChild(el);
    document.body.appendChild(el);
  },
});


Vue.config.devtools = true;
Vue.config.productionTip = false;


// Vue.config.productionTip = false

export default Vue;
